// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"HX0Sa","modalControls":"_2ygkf","deleteBtnWrapper":"_1ytZa"};